// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import Paging from "./Paging";
import SocialFile from "entity/SocialFile";

import { RestController, RestRequest } from "./RestController";

export default class SocialFileController extends RestController {

    /*
     Add CTAItem files
     */

    addCTAItemFiles(CTAItemId: number, socialFileIds: string[]): Promise<void> {
        let request = new RestRequest("/api/v1/file/ctaitem", "POST", socialFileIds, { CTAItemId: CTAItemId });
        return this.requestVoid(request);
    }

    /*
     Delete file
     */

    deleteFile(socialRoomSetId: string, socialFileId: string): Promise<void> {
        let request = new RestRequest("/api/v1/file", "DELETE", null, { socialRoomSetId: socialRoomSetId, socialFileId: socialFileId });
        return this.requestVoid(request);
    }

    /*
     Get CTAItem files
     */

    getCTAItemFiles(CTAItemId: number, page?: Paging): Promise<SocialFile[]> {
        let request = new RestRequest("/api/v1/file/ctaitem", "GET", null, { CTAItemId: CTAItemId });
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<SocialFile[]>;
    }

    /*
     Get an URL for downloading a file or files
     */

    getDownloadURL(socialRoomSetId: string, socialFileIds: string[]): Promise<string> {
        let request = new RestRequest("/api/v1/file/download/url", "POST", socialFileIds, { socialRoomSetId: socialRoomSetId });
        return this.request(request, null) as Promise<string>;
    }

    /*
     Get files
     */

    getFiles(socialRoomSetId: string, page?: Paging): Promise<SocialFile[]> {
        let request = new RestRequest("/api/v1/file", "GET", null, { socialRoomSetId: socialRoomSetId });
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<SocialFile[]>;
    }

    /*
     Remove CTAItem files
     */

    removeCTAItemFiles(CTAItemId: number, socialFileIds: string[]): Promise<void> {
        let request = new RestRequest("/api/v1/file/ctaitem/remove", "POST", socialFileIds, { CTAItemId: CTAItemId });
        return this.requestVoid(request);
    }

    /*
     Upload file
     */

    uploadFile(socialRoomSetId: string, fileName: string, fileType: string, fileSize: number, fileBytes: any): Promise<SocialFile> {
        let request = new RestRequest("/api/v1/file", "POST", fileBytes, { socialRoomSetId: socialRoomSetId, fileName: fileName, fileType: fileType, fileSize: fileSize });
        return this.request(request, null) as Promise<SocialFile>;
    }

}
